import omitBy from "lodash/omitBy";
import reduce from 'lodash/reduce';
import at from 'lodash/at';
import isNull from 'lodash/isNull';
import mitt from 'mitt';
import orderBy from 'lodash/orderBy'

import {
  USER_POSITION,
  FORM_CHECKBOX_LIST,
  SCREEN_SIZE,
  searchMapper 
} from "~/constants/common";
import { parsePhoneNumber } from 'awesome-phonenumber'

export function getSearchInitValue() {
  return {
    selectedColor: 0, // COLOR_TYPE.SOLID, #YB_ZE-21
    materialOnly: false,
    apexYarn: false,
    datamallYarn: false,
    checkedColor: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    selectedPrice: null,
    keyword: "",
    selectedCompany: "",
    selectedSeason: [],
    selectedCharacteristics: [],
    selectedFunctions: [],
    selectedCertifications: [],
    yarnCount: "",
    selectedType: null,
    selectedProperGauge: null,
    selectedEnds: 0,
    selectedMaterial: [],
    selectedOptionMaterial: [],
    selectedDetailOptionMaterial: [],
    selectedOptionWool: [],
    selectedSubSilk: [],
    selectedSubCotton: [],
    selectedSubPolyester: [],
    materialLog: [],
    country: null,
    status: [],
    selectedRecommend: false,
    selectedValidEco: 0,
  };
}

export function provideMappedSearch(target) {
  let colored = false;
  const search = reduce(
    target,
    (previous, current, key) => {
      if (target[key] !== null && target[key] !== "") {
        if (Array.isArray(current)) {
          if (
            current.length > 0 &&
            FORM_CHECKBOX_LIST.some((target) => {
              return target === key;
            })
          ) {
            previous[searchMapper[key] || key] = current.join();
          }
        } else if (typeof current === "boolean") {
          previous[searchMapper[key] || key] = Number(current);
        } else {
          previous[searchMapper[key] || key] = current;
        }
      }
      return previous;
    },
    {}
  );
  const checkedColor = [];
  for (let i = 0; i < target.checkedColor.length; i++) {
    colored = colored || !!target.checkedColor[i];
    target.checkedColor[i] && checkedColor.push(target.checkedColor[i]);
  }
  search.colored = colored;
  search.colors = checkedColor.join();
  return search;
}

export function provideLocationObject(
  page,
  { path = null, params = null, query = {} }
) {
  return omitBy(
    {
      path,
      query: {
        page,
        ...query,
      },
      params,
    },
    isNull
  );
}

export function formatDate(date) {
  if (date === null) {
    return "";
  }
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function checkManager({ role }) {
  return [USER_POSITION.CUSTOMER_MANAGER].includes(role);
}

export function isTabletScreen() {
  return !process.server && window.innerWidth < SCREEN_SIZE.LG;
}

export function getTrueKey(result, key, falsy) {
  return result ? result[key] : falsy;
}

export const commonAnimationConfig = {
  enter(element) {
    let height = element.clientHeight
    return {
      height: [height, 0],
      opacity: [Math.random() * 0.5 + 0.5, 0]
    };
  },
  leave: {
    height: 0,
    opacity: 0,
  },
}

export function setNotificationConfig({
  groupName = "alerts",
  text,
  type = "success",
  ...rest
}) {
  return {
    group: groupName,
    text,
    animation: commonAnimationConfig,
    type,
    ...rest,
  };
}

export function apiWrapper(callback) {
  return new Promise((resolve, reject) => {
    callback()
      .then((result) => {
        resolve(result);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export function provideFullName({ firstName, middleName, lastName }) {
  return `${!firstName ? "" : firstName} ${!middleName ? "" : middleName} ${
    !lastName ? "" : lastName
  }`;
}

export function isValueExist(value) {
  if (typeof value === "number") {
    return true;
  }
  return !!value;
}

export function returnPropertyFunc(key) {
  return (target) => {
    return target[key];
  };
}

export function returnWhenFind(list, callback, successCallback) {
  return successCallback(list.find(callback));
}

export function setResultOnlyTrue(maybe, target, key, value) {
  if (maybe) {
    target[key] = value || maybe;
  }
}

export function returnKeyOrFalsy(target, key, falsyValue) {
  if (target) {
    return target[key];
  } else {
    return falsyValue;
  }
}

export function setArray(array, index, value) {
  array[index] = value;
  return array;
}

export function doByCondition(
  condition,
  truthyFunction,
  falsyFunction,
  finalFunction
) {
  const result = {};
  if (condition) {
    result.true = truthyFunction && truthyFunction(condition);
  } else {
    result.false = falsyFunction && falsyFunction(condition);
  }
  result.final = finalFunction && finalFunction(condition);
  return result;
}

export function operateTruthyList({ maybe, target, list, operator, callback }) {
  if (maybe) {
    list[operator](callback(target));
  }
  return list;
}

export function doWithTruthyValue(target, callback) {
  if (target) {
    return target;
  } else {
    return callback && callback();
  }
}

export function provideDateOfBirth({ year, month, day }) {
  if (year && month && day) {
    return {
      dateOfBirth: `${year}-${month}-${day}`,
    };
  }
  return {};
}

export function getValueByLocalePriority({ locales, targetList, targetKey }) {
  for (const locale of locales) {
    const match = targetList.find(item => item.code === locale);
    if (match?.[targetKey]) return match[targetKey];
  }
  return "";
}

export function handleLogoData(form, key) {
  const target = { ...form };
  if (target[key]) {
    target[key] = target[key].split(",")[1];
  }
  return target;
}

export function getErrorI18n(error, errorCodePath) {
  return `error.${at(error, errorCodePath)[0]}`;
}

const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate();

export function addMonths(input, months) {
  const date = new Date(input);
  date.setDate(1);
  date.setMonth(date.getMonth() + months);
  date.setDate(
    Math.min(
      input.getDate(),
      getDaysInMonth(date.getFullYear(), date.getMonth() + 1)
    )
  );
  return date;
}

export function getUppercaseUuidv4(crypto) {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4))))
      .toString(16)
      .toUpperCase()
  );
}

export function downloadLogFile({ data, headers }) {
  const headersObject = Object.fromEntries(headers.entries())
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", headersObject["content-disposition"].split('"')[1]);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export function scrollToFeatureOnIndex() {
  const intervalIndex = setInterval(() => {
    const targetDom = window.document.querySelector(".featureGap.first");
    if (targetDom) {
      clearInterval(intervalIndex);
      window.document
        .querySelector(".featureGap.first")
        .scrollIntoView({ behavior: "smooth" });
    }
  }, 200);
}

export function waitForValue(checkCallback, time, remainCallback) {
  const stop = setInterval(() => {
    if (checkCallback()) {
      clearInterval(stop);
      remainCallback();
    }
  }, time);
}

export function generateRandomeKey(length) {
  return [...Array(length || 30)]
    .map(() => Math.random().toString(36)[2])
    .join("");
}

export function callPostWithToken(url, data, cancelToken, config = {}) {
  const restConfig = {
    ...config,
  };
  if (cancelToken) {
    restConfig.cancelToken = cancelToken.token;
  }
  return usePost(url, data, restConfig);
}

export function mergeArraysByKey(a1, a2, key) {
  const result = a1.map((itm) => ({
    ...itm,
    ...a2.find((item) => item[key] == itm[key]),
  }));

  return [...result];
}

export function makeId() {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < 6; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const biggerScreenSizeOfXs = () => {
  return !process.server && window.innerWidth >= SCREEN_SIZE.XS;
};

export const eventBus = mitt();

export function handleApiResult (
  apiResult,
  callback,
  { notify, t, store, showingSpinner } = {},
  handleError,
  rollback
) {
  store && store.setSpinner();
  apiResult
    .then((apiResult) => {
      callback && callback(apiResult);
      if (notify && t) {
        notify(setNotificationConfig({ text: t("common.10307") }))
      }
    })
    .catch((error) => {
      if (error.statusCode === 403) {
        throw error;
      }
      handleError && handleError(error);
      rollback && rollback();
    })
    .finally(() => {
      store && !showingSpinner && store.hideSpinner();
    });
  return apiResult
};

export const setImageFromInput = ({
  file,
  target,
  key,
  name,
  data,
}) => {
  doByCondition(key, () => {
    target[key] = ''
  })
  target.fileSize = file.size
  target[name] = file.name
  target[data] = file.base64
}

export const getFormattedDate = (date) => {
  if (date) {
    const year = date.getFullYear()
    let month = (1 + date.getMonth()).toString()
    month = month.length > 1 ? month : '0' + month
    let day = date.getDate().toString()
    day = day.length > 1 ? day : '0' + day
    return year + '/' + month + '/' + day
  }
}

export const removeRegionCode = (phoneNumber) => {
  const result = parsePhoneNumber(phoneNumber)
  if (result.valid) {
    return result.number.input
  } else {
    return ''
  }
}

export const provideColorByPage = (colorValue, colorList, currentIndex, searchPage) => {
  if (searchPage) {
    return colorValue
  } else {
    return colorList[currentIndex]
  }
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const groupDomain = (target, key) => {
  const countingGroup = reduce(
    target,
    (previous, current) => {
      if (!previous[current.domain]) {
        previous[current.domain] = 0
      }
      previous[current.domain] += 1
      return previous
    },
    {}
  )
  const result = reduce(
    target,
    (previous, current) => {
      if (!previous[current.domain]) {
        previous[current.domain] = true
      }
      return previous
    },
    {}
  )
  return orderBy(
    target.map(value => {
      return {
        ...value
      }
    }),
    ['domainTotal', 'domain'],
    ['desc', 'desc']
  ).map((current, index) => {
    if (result[current.domain]) {
      delete result[current.domain]
      return {
        groupCount: countingGroup[current.domain],
        index,
        first: true,
        ...current
      }
    }
    return {
      groupCount: countingGroup[current.domain],
      index,
      first: false,
      ...current
    }
  })
}

export const normalizeEmailList = (list) => {
  if (!Array.isArray(list)) return ''

  return list
    .map(i => typeof i === 'object' ? i.text : i)
    .map(i => i?.trim())
    .filter(Boolean)
    .join(',')
}

export const parseEmailList = (str) => {
  if (!str) return []
  if (Array.isArray(str)) {
    return str.map(item =>
      typeof item === 'string'
        ? { text: item }
        : item
    )
  }
  return str
    .split(',')
    .map(i => i.trim())
    .filter(Boolean)
    .map(text => ({ text })) // convert to format TagsInput
}
